import Taxonomy from './taxonomy.vue'
import ListTaxonomy from './list-taxonomy.vue'
import ViewTaxonomy from './view-taxonomy.vue'
export default {
  path: '/taxonomy',
  meta: {
    nav: {
      icon: 'device_hub',
      childDefault: true // grab first child as main route
    },
    breadCrumb: 'Taxonomy'
  },
  component: Taxonomy,
  children: [
    {
      path: '',
      name: 'taxonomy',
      meta: {
        breadCrumb: 'List'
      },
      component: ListTaxonomy
    },
    {
      path: 'view/:id',
      props: true,
      name: 'view-taxonomy',
      meta: {
        breadCrumb: 'View'
      },
      component: ViewTaxonomy
    }
  ]
}
